import { render, staticRenderFns } from "./AssignTeam.vue?vue&type=template&id=45ecf36c&scoped=true"
import script from "./AssignTeam.vue?vue&type=script&lang=js"
export * from "./AssignTeam.vue?vue&type=script&lang=js"
import style0 from "./AssignTeam.vue?vue&type=style&index=0&id=45ecf36c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ecf36c",
  null
  
)

export default component.exports